export default __webpack_public_path__ + "static/media/027-umbrella.d1e79a8c.svg";